<template>
    <div>
        <div v-show="passed_filter_left">
                <designer-question-select-frame-sidepanel :fabricator="fabricator"
                                                          :door-range="doorRange"
                                                          :frame-material="frameMaterial"
                                                          :frame-style-id="frame_id"
                                                          v-model:target="target.left"
                                                          :frame-colour-external="frameColourExternal"
                                                          :frame-colour-internal="frameColourInternal"
                                                          :title="'Select Left Side Panel Style'"
                                                          :measurement.sync="measurements.left_width"
                                                          measurement-key="left_width"
                                                          measurement-label="Enter your Left Width"
                                                          :component_id="'left_side_panel_style'"
                ></designer-question-select-frame-sidepanel>

                <!--<div v-if="passed_filter_left_comp">-->
                    <!--<designer-question-select-comp-options :fabricator="fabricator"-->
                                                           <!--v-model:target="target.left_composite_id"-->
                                                           <!--:door-range="doorRange"-->
                                                           <!--:title="'Select Left Side Panel Composite Style'"-->
                                                           <!--:component_id="'left_side_panel_composite_style'"-->
                    <!--&gt;</designer-question-select-comp-options>-->

                    <!--<div v-if="passed_filter_left_comp_glass">-->
                        <!--<designer-question-select-comp-glass :fabricator="fabricator"-->
                                                             <!--v-model:target="target.left_composite_glass_id"-->
                                                             <!--:comp-slab="target.left_composite_id"-->
                                                             <!--:laminated-glass="laminatedGlass"-->
                                                             <!--:title="'Select Left Side Panel Composite Glass'"-->
                                                             <!--:component_id="'left_side_panel_composite_glass'"-->
                        <!--&gt;</designer-question-select-comp-glass>-->

                        <!--<designer-question-glass-backing-design :fabricator="fabricator"-->
                                                                <!--v-model:target="target.left_composite_backing_glass_id"-->
                                                                <!--:slab="target.left_composite_id"-->
                                                                <!--:glass-design="target.left_composite_glass_id"-->
                                                                <!--:component_id="'left_side_panel_composite_backing_glass'"-->
                        <!--&gt;</designer-question-glass-backing-design>-->

                    <!--</div>-->
                <!--</div>-->

                <div v-show="passed_filter_left_glass">
                    <senator-designer-question-select-side-glass :fabricator="fabricator"
                                                         v-model:target="target.left_panel_glass_id"
                                                         :frame-combination="frame_id"
                                                         :secured-by-design="securedByDesign"
                                                         :side-variant="target.left"
                                                         :title="'Select Left Side Panel Glass'"
                                                         :component_id="'left_side_panel_glass'"
                                                         :slab="slab"
                                                         :type-range="doorRange"
                                                         :glass-design="glassDesign"
                    ></senator-designer-question-select-side-glass>

                    <senator-designer-question-select-side-glass-obscure :fabricator="fabricator"
                                                                 v-model:target="target.left_panel_backing_glass_id"
                                                                 :panel-glass-id="target.left_panel_glass_id"
                                                                 :title="'Select Left Side Panel Backing Glass'"
                                                                 :component_id="'left_side_panel_backing_glass'"
                                                                 :backing-glass="backingGlass"
                                                                 :solid_slab="solid_slab"
                                                                 :slab="slab"
                    ></senator-designer-question-select-side-glass-obscure>
                </div>
        </div>
        <div v-show="passed_filter_right">
                <designer-question-select-frame-sidepanel :fabricator="fabricator"
                                                          :door-range="doorRange"
                                                          v-model:target="target.right"
                                                          :frame-material="frameMaterial"
                                                          :frame-style-id="frame_id"
                                                          :frame-colour-external="frameColourExternal"
                                                          :frame-colour-internal="frameColourInternal"
                                                          :title="'Select Right Side Panel Style'"
                                                          :measurement.sync="measurements.right_width"
                                                          measurement-key="right_width"
                                                          measurement-label="Enter your Right Width"
                                                          :component_id="'right_side_panel_style'"
                ></designer-question-select-frame-sidepanel>

                <!--<div v-if="passed_filter_right_comp">-->
                    <!--<designer-question-select-comp-options :fabricator="fabricator"-->
                                                           <!--v-model:target="target.right_composite_id"-->
                                                           <!--:door-range="doorRange"-->
                                                           <!--:title="'Select Right Side Panel Composite Style'"-->
                                                           <!--:component_id="'right_side_panel_composite_style'"-->
                    <!--&gt;</designer-question-select-comp-options>-->

                    <!--<div v-if="passed_filter_right_comp_glass">-->
                        <!--<designer-question-select-comp-glass :fabricator="fabricator"-->
                                                             <!--v-model:target="target.right_composite_glass_id"-->
                                                             <!--:comp-slab="target.right_composite_id"-->
                                                             <!--:laminated-glass="laminatedGlass"-->
                                                             <!--:title="'Select Right Side Panel Composite Glass'"-->
                                                             <!--:component_id="'right_side_panel_composite_glass'"-->
                        <!--&gt;</designer-question-select-comp-glass>-->

                        <!--<designer-question-glass-backing-design :fabricator="fabricator"-->
                                                                <!--v-model:target="target.right_composite_backing_glass_id"-->
                                                                <!--:slab="target.right_composite_id"-->
                                                                <!--:glass-design="target.right_composite_glass_id"-->
                                                                <!--:component_id="'right_side_panel_composite_backing_glass'"-->
                        <!--&gt;</designer-question-glass-backing-design>-->
                    <!--</div>-->
                <!--</div>-->

            <div v-show="passed_filter_right_glass">
                <senator-designer-question-select-side-glass :fabricator="fabricator"
                                                     v-model:target="target.right_panel_glass_id"
                                                     :frame-combination="frame_id"
                                                     :secured-by-design="securedByDesign"
                                                     :side-variant="target.right"
                                                     :slab="slab"
                                                     :type-range="doorRange"
                                                     :title="'Select Right Side Panel Glass'"
                                                     :component_id="'right_side_panel_glass'"
                                                     :glass-design="glassDesign"
                ></senator-designer-question-select-side-glass>

                <senator-designer-question-select-side-glass-obscure :fabricator="fabricator"
                                                             v-model:target="target.right_panel_backing_glass_id"
                                                             :panel-glass-id="target.right_panel_glass_id"
                                                             :title="'Select Right Side Panel Backing Glass'"
                                                             :component_id="'right_side_panel_backing_glass'"
                                                             :backing-glass="backingGlass"
                                                             :solid_slab="solid_slab"
                                                             :slab="slab"
                ></senator-designer-question-select-side-glass-obscure>
            </div>

        </div>
        <div v-show="passed_filter_top_glass">

          <designer-question-select-frame-sidepanel-top :fabricator="fabricator"
                                                        :door-range="doorRange"
                                                        :frame-material="frameMaterial"
                                                        :frame-combination="frameStyle.frame_id"
                                                        v-model:target="target.top"
                                                        :frame-style-id="frame_id"
                                                        :frame-colour-external="frameColourExternal"
                                                        :frame-colour-internal="frameColourInternal"
                                                        :title="'Select Top Panel Style'"
                                                        :component_id="'top_panel_style'"
          ></designer-question-select-frame-sidepanel-top>

                <senator-designer-question-select-side-glass :fabricator="fabricator"
                                                     v-model:target="target.top_panel_glass_id"
                                                     :frame-combination="frame_id"
                                                     :secured-by-design="securedByDesign"
                                                     :side-variant="0"
                                                     :slab="slab"
                                                     :type-range="doorRange"
                                                     :title="'Select Top Panel Glass'"
                                                     :component_id="'top_panel_glass'"
                                                     :glass-design="glassDesign"
                ></senator-designer-question-select-side-glass>

                <senator-designer-question-select-side-glass-obscure :fabricator="fabricator"
                                                             v-model:target="target.top_panel_backing_glass_id"
                                                             :panel-glass-id="target.top_panel_glass_id"
                                                             :title="'Select Top Panel Backing Glass'"
                                                             :component_id="'top_panel_backing_glass'"
                                                             :backing-glass="backingGlass"
                                                             :solid_slab="solid_slab"
                                                             :slab="slab"
                ></senator-designer-question-select-side-glass-obscure>
        </div>


        <div class="designeroption" v-show="can_have_bottom_panel">
            <h3>Lower Side Panel Type</h3>
            <senator-designer-question-collection :fabricator="fabricator"
                                                  :slab="slab"
                                                  v-model:target="target.lower_sidepanel_type"
                                                  :question="'side_panel'"
            ></senator-designer-question-collection>
        </div>
    </div>
</template>

<script type="text/ecmascript-6">
    import DesignerQuestionSelectFrameSidePanels from "../DesignerQuestionSelectFrameSidePanels.vue";

    export default {
        mixins: [
            DesignerQuestionSelectFrameSidePanels
        ],
        props: {
            glassDesign: {
                required: true,
            },
            backingGlass: {
                required: true,
            },
            solid_slab: {
              required: true,
            },
            slab: {
              required: true,
            }
        },
        computed: {
            can_have_bottom_panel(){
                return this.has_midrail && (this.passed_filter_left_glass || this.passed_filter_right_glass)
            },
            has_midrail() {
                return this.localTarget.left == 4 || this.localTarget.left == 18 || this.localTarget.right == 4 || this.localTarget.right == 18;
            },
        }
    }
</script>
